import styled from 'styled-components';

import { getThemeProps } from 'ravenjs/utils/theme';

const UserNavStyled = styled.div`
    align-items: center;
    cursor: pointer;
    font-weight: 100;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;

    /* Hide focus outline - parent AvatarWrapper shows ring via :focus-within */
    &:focus {
        outline: none;
    }

    ${getThemeProps('UserNav.styles')};
`;

export default UserNavStyled;
